import { Checkbox } from "../../components/Checkbox";
import { sameNodePosition } from "../../components/markdown/utils";
import React, { memo } from "react";
export const InputBlock = memo(({ type, checked, className, onChange, ref, ...props }) => {
    const inputRef = React.useRef(null);
    React.useImperativeHandle(ref, () => inputRef.current);
    if (type !== "checkbox") {
        return (React.createElement("input", { ref: inputRef, type: type, checked: checked, className: className, ...props }));
    }
    const handleCheckedChange = (isChecked) => {
        onChange === null || onChange === void 0 ? void 0 : onChange({
            target: { type: "checkbox", checked: isChecked },
        });
    };
    return (React.createElement("div", { className: "inline-flex items-center" },
        React.createElement(Checkbox, { ref: inputRef, checked: checked, className: "translate-y-[3px]", onCheckedChange: handleCheckedChange })));
}, (prev, next) => sameNodePosition(prev.node, next.node) &&
    prev.type === next.type &&
    prev.checked === next.checked &&
    prev.className === next.className);
InputBlock.displayName = "InputBlock";
//# sourceMappingURL=InputBlock.js.map